const Config = {
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_AUTH_BASE_URL: process.env.REACT_APP_AUTH_BASE_URL,
};

export default Config;
